import React from "react";
import CourseDetails from "./CourseDetails";


const CourseInfo = ({ courseInfo, agency, categoryIndex }) => {
  
  return (
  <>
    {
      courseInfo.map(({title, details}, courseIndex) => {
        let courseDetailsPresent = Object.keys(details).length > 0;
        return (
          <li key={`${title}ListItem${courseIndex}`}>
              <p className="coursesClassTitle">{title}</p>
                {
                  courseDetailsPresent ? 
                  <CourseDetails 
                    agency={agency}
                    categoryIndex={categoryIndex}
                    courseIndex={courseIndex}
                    details={details}
                    />
                  :
                  null
                }
          </li>
        )
      })
    }
  </> 
  )
}

export default CourseInfo;